import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { CalendarEventType } from "../../calendars/_types/calendar-event-type";

export class WorkerCalendarEvent extends Resource {
    public override type = 'workerCalendarEvents';
    
    @prop()  
    @required()  
    public workerId!: string;  

    @prop()    
    @required()
    public date!: Date;  

    @prop()    
    public description!: string;  

    @prop()  
    @required()  
    public calendarEventTypeId!: string;      
    public calendarEventType!: CalendarEventType;

    @prop()        
    public start!: any;  

    @prop()        
    public end!: any; 
    
    @prop()
    public keepCaseServices:boolean = true;
    
    @prop()
    public keepGuardShifts:boolean = true;

    public list_dates: Date[] = [];
    
}